export default {
      id: "ic_copy-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic_copy-usage",
      toString: function () {
        return this.url;
      }
    }